/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useAuth } from "../providers/AuthProvider";
import { useTheme } from "../providers/CustomThemeProvider";

interface ModalProps {
	show: boolean;
	onHide: () => void;
}

interface IUserInfo {
	id: string;
	name: string;
	email: string;
	imageUrl?: string;
	password?: string;
	provider: object;
	googleEmail?: string;
	providerId?: string;
	apiKey?: string;
	usd: string;
	cny: string;
}

function ShowBalanceModal(props: ModalProps) {
	const { show, onHide } = props;
	const { t, i18n } = useTranslation();
	const user = useAuth()?.userInfo;
	const { isDarkMode, switchTheme } = useTheme();

	return (
		<Modal
			show={show}
			onHide={onHide}
			centered
			className={`set-up-modal ${isDarkMode ? "dark-theme" : "light-theme"}`}
		>
			<Modal.Header closeButton>
				<Modal.Title>{t("op.balance")}</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<div className="d-flex align-items-center justify-content-between mb-2">
					{i18n.language == "en" ? (
						<>USD ${parseFloat(user?.usd ?? "0").toFixed(2)}</>
					) : (
						<>
							CNY $
							{parseFloat((Number(user?.usd) / 7).toString() ?? "0").toFixed(2)}
						</>
					)}
				</div>
				{/* <div className="d-flex align-items-center justify-content-between mb-2">
					CNY: {user?.cny}
				</div> */}
			</Modal.Body>
		</Modal>
	);
}

export default ShowBalanceModal;
